import React, { useState, useEffect } from 'react';
import AxiosClient from '../../assets/AxiosClient';
import { useNavigate, useParams } from 'react-router-dom';
import { useStateContext } from '../../Contexts/ContextProvider';
import { DataTable, PageHeader } from '../../componants/Workspace';

const SpeakerList = () => {
  const [speakers, setSpeakers] = useState([]); 
  const {id} = useParams () ;

  const navigate = useNavigate();
  const {API} = useStateContext () ;

  useEffect(() => {
    const fetchSpeakers = async () => {
      try {
        const response = await AxiosClient.get(`/conference/${id}/speakers`);
        setSpeakers(response.data); 
        console.log(response.data)  ;
      } catch (error) {
        console.error('Error fetching speakers:', error);
      }
    };

    fetchSpeakers();
  }, [id]);

  const moveSpeakerUp = (index) => {
    if (index > 0) {
      const newSpeakers = [...speakers];
      [newSpeakers[index - 1], newSpeakers[index]] = [
        newSpeakers[index],
        newSpeakers[index - 1],
      ];
      setSpeakers(newSpeakers);
    }
  };

  const moveSpeakerDown = (index) => {
    if (index < speakers.length - 1) {
      const newSpeakers = [...speakers];
      [newSpeakers[index], newSpeakers[index + 1]] = [
        newSpeakers[index + 1],
        newSpeakers[index],
      ];
      setSpeakers(newSpeakers);
    }
  };

  const saveRanks = async () => {
    try {
      const updatePromises = speakers.map((speaker, index) => {
        const newRank = index + 1;
        return AxiosClient.put(`/speakers/update_rank/${speaker.id}`, { rank: newRank });
      });

      await Promise.all(updatePromises);
      console.log('Ranks updated successfully!');
      navigate(-1);
    } catch (error) {
      console.error('Error updating ranks:', error);
    }
  };

  return (
    <>
      <PageHeader
        title="Speaker order"
        description="Arrange how speakers appear for this conference."
        actions={(
          <>
            <button className="btn btn-primary" onClick={saveRanks} type="button">Save order</button>
            <button className="btn btn-outline-secondary" onClick={() => navigate(-1)} type="button">Cancel</button>
          </>
        )}
      />
      <DataTable>
        <thead className="text-primary">
          <tr>
          <th className="text-center">image</th>

            <th className="text-center">Name</th>
            <th className="text-center">Title</th> 
             
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {speakers.map((speaker, index) => (
            <tr
              key={speaker.id}
              className={`text-center ${
                index % 2 === 0 ? 'bg-gray-50' : 'bg-white' // Alternating row colors
              } transition-bg duration-1000`}
            >
             <td> 
              <img
                  src={API + speaker.image}
                  alt={speaker.name}
                  className=" avatar avatar-lg p-0 "
                />
              </td>
              <td>
                {speaker.name}</td>
              <td>{speaker.title}</td>
              <td>
                <button className="btn btn-outline-secondary btn-sm" onClick={() => moveSpeakerUp(index)} type="button">
                  <i className="material-icons" aria-hidden="true">arrow_upward</i>Move up
                </button>
                <button className="btn btn-outline-secondary btn-sm" onClick={() => moveSpeakerDown(index)} type="button">
                  <i className="material-icons" aria-hidden="true">arrow_downward</i>Move down
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </DataTable>
    </>
  );
};

export default SpeakerList;
